/*PROJECT EDITOR*/

draggable = Window.draggable;

Vue.component('projecteditor',{
    template:'#projecteditor-template',
    data:function(){
        return{
            client: [],
            project: [],
            backupRecord:[],
            brands:[],
            subBrands:[],
            activeClient:'',
            activeBrand:'',
            activeBrandId:'',
            activeSubBrand:'',
            activeSubBrandId:'',
            projectName:'',
            projectDeadLine:'',
            projectStart:'',
            projects:'',
            recentProjectNumbers:[],
            completionMonth:'',
            briefTemplates:[],
            activeDivision:[],
            activeDivisionId:'',
            dropZoneInstance:'',
            dropZoneFiles:[],
            loaderIsActive: false,
            maxFileSize: 80, /* MB */
            phase_list: [],
            invoice_required: null,
            project_stages:[
            ]
        };
    },
    created:function(){

        activeInstance = this;

        activeInstance.getBriefTemplates();
        activeInstance.loadPhaseList();

        setTimeout(function(){
            activeInstance.project_id = $('#project_editor').attr('data-id');
            activeInstance.loadProjectDetails();
        },300);

        setTimeout(function(){
            $(function () {
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD HH:00',
                    locale: 'hu'
                });
            });
        },300);

        setTimeout(function(){

            var token = $("meta[name='csrf-token']").attr('content');
            // Dropzone class:
            activeInstance.dropZoneInstance = $("#dropzone").dropzone({
                url: baseURL+'/admin/project/brief/file_upload',
                addRemoveLinks: true,
                maxFilesize: activeInstance.maxFileSize,
                headers: {
                    'X-CSRF-TOKEN': token
                },
                addedfile: function(file) {
                    // Now attach this new element some where in your page
                },
                init: function() {
                    this.on("addedfile", function(file, response) {

                        // PREVENT FILE DUPLICATES
                        if (this.files.length) {
                            var _i, _len;
                            for (_i = 0, _len = this.files.length; _i < _len - 1; _i++) // -1 to exclude current file
                            {
                                if(this.files[_i].name === file.name && this.files[_i].size === file.size && this.files[_i].lastModifiedDate.toString() === file.lastModifiedDate.toString())
                                {
                                    errorNotification("Ezt a file-t már feltöltötted a kommenthez.");
                                    return false;
                                }
                            }
                        }

                        if (file.size > activeInstance.maxFileSize * 1000000) {
                            errorNotification("Túl nagy file. Megengedett maximális méret: " + activeInstance.maxFileSize + "MB");
                            return;
                        }

                        console.log(file);
                        console.log(response);
                        var fileRecord = {};
                        fileRecord.name = file.name;
                        fileRecord.progress = 0;
                        fileRecord.bytesSent = 0;
                        fileRecord.file = file;
                        fileRecord.file_record_id = '';
                        activeInstance.dropZoneFiles.push(fileRecord);
                    });
                    this.on("success", function(file, response) {
                        console.log('succesfile:');
                        console.log(response);
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.file_record_id=response;
                            }
                        });
                    });
                    this.on("uploadprogress", function(file) {
                        $.each(activeInstance.dropZoneFiles,function(index,dropZoneFile){
                            if(dropZoneFile.name==file.name){
                                dropZoneFile.progress=file.upload.progress;
                                dropZoneFile.bytesSent=file.upload.bytesSent;
                            }
                        });
                        console.log(file);
                        console.log(file.name);
                        console.log(file.upload.progress);
                        console.log(file.upload.bytesSent);
                    });
                }
            });
            $('#dropzone').addClass('dropzone');
        },200);
    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            console.log(data);

            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        },

        //ON USER SELECTION -> ADD USER (IF NOT ALREADY ASSIGNED)
        'autocomplete-user:selected': function(data){

            var found = false;

            $.each(activeInstance.project.assignees,function(index,assignee){
                if(data.id==assignee.id){
                    found = true;
                }
            });

            if(found==false) {
                activeInstance.project.assignees.push(data);
            }

            setTimeout(function() {
                $('#usersearchfield').val('');
            },60);

        }
    },
    methods:{
        syncIndexes:function(){

        },
        createStage:function() {
            vex.dialog.open({
                message: 'Az új szakasz adatai:',
                input:[
                    '<div class="vex-custom-field-wrapper">',
                    '<label for="title">Megnevezés:</label>',
                    '<div class="vex-custom-input-wrapper title">',
                    '<input name="title" type="text" />',
                    '</div>',
                    '</div>',
                    '<div class="vex-custom-field-wrapper">',
                    '<label for="deadline">Határidő</label>',
                    '<div class="vex-custom-input-wrapper deadline">',
                    '<div class="input-group date" id="datetimepicker7">',
                    '<input type="text" class="form-control disabled" id="field_date" name="deadline" />',
                    '<span class="input-group-addon">',
                    '<span class="glyphicon glyphicon-calendar"></span>',
                    '</span>',
                    '</div>',
                    '</div>',
                    '</div>'

                ].join(''),
                callback: function (data) {
                    if (!data) {
                        return console.log('Cancelled')
                    }


                    var nextIndex = activeInstance.project.stages.length+1;

                    var record = {
                        index:nextIndex,
                        title:data.title,
                        deadline:data.deadline
                    };

                    console.log(record);

                    activeInstance.project.stages.push(record);
                },
                afterOpen:function(){

                    var now= moment();
                    console.log(now);

                    //INITIATE DATETIMEPICKER
                    $('#datetimepicker7').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu',
                        defaultDate: now.format("YYYY-MMM-DD"),
                        minDate: now.format("YYYY-MMM-DD")

                    });
                }
            })
        },
        editStage:function(stage) {
            vex.dialog.open({
                message: stage.title+':',
                input:[
                    '<div class="vex-custom-field-wrapper">',
                    '<label for="title">Megnevezés:</label>',
                    '<div class="vex-custom-input-wrapper title">',
                    '<input name="title" type="text" value="'+stage.title+'" />',
                    '</div>',
                    '</div>',
                    '<div class="vex-custom-field-wrapper">',
                    '<label for="deadline">Határidő</label>',
                    '<div class="vex-custom-input-wrapper deadline">',
                    '<div class="input-group date" id="datetimepicker7">',
                    '<input type="text" class="form-control disabled" id="field_date" value="'+stage.deadline+'" name="deadline" />',
                    '<span class="input-group-addon">',
                    '<span class="glyphicon glyphicon-calendar"></span>',
                    '</span>',
                    '</div>',
                    '</div>',
                    '</div>'

                ].join(''),
                callback: function (data) {
                    if (!data) {
                        return console.log('Cancelled')
                    }

                    stage.deadline=data.deadline;
                    stage.title=data.title;

                },
                afterOpen:function(){

                    var now= moment();
                    console.log(now);

                    //INITIATE DATETIMEPICKER
                    $('#datetimepicker7').datetimepicker({
                        format: 'YYYY-MM-DD',
                        locale: 'hu',
                        defaultDate: now.format("YYYY-MMM-DD"),
                        minDate: now.format("YYYY-MMM-DD")

                    });
                }
            })
        },
        destroyStage:function(stage){

            vex.dialog.confirm({
                message: 'Biztosan törlöd a szakszt? ('+stage.title+')',
                callback: function (value) {
                    console.log(stage);
                    activeInstance.project.stages.$remove(stage);
                }
            })


        },
        loadPhaseList: function() {
            showLoadingOverlay();
            axios.get(baseURL+'/api/project/phase/list')
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.phase_list = response.data;
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);

                });
        },
        closeProject:function(project){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/close', {
                'project_id':project.id
            })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response);
                    project.status='closed';
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        openProject:function(project){

            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/open', {
                'project_id':project.id
            })
                .then(function (response) {
                    $('body').LoadingOverlay("hide");
                    console.log(response);
                    project.status='open';
                })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);

                });
        },
        //DELETE A FILE ATTACHMENT
        deleteFileAttachment:function(file){
            showLoadingOverlay();
            axios.post(baseURL+'/admin/project/brief/remove_uploaded_file_id', {
                file_record_id: file.file_record_id
            }).then(function (response) {
                $('body').LoadingOverlay("hide");
                activeInstance.dropZoneFiles.$remove(file);
            })
                .catch(function (error) {
                    $('body').LoadingOverlay("hide");
                    console.log(error);
                });
        },
        //GET THE BRIEF TEMPLATES FOR DIVISIONS
        getBriefTemplates:function(){
            showLoadingOverlay();
            axios.get(baseURL+'/api/division_brief_templates?type=project')
                .then(function(response){
                    $('body').LoadingOverlay("hide");
                    activeInstance.briefTemplates = response.data;
                });
        },
        //IMPORT BRIEF TEMPLATE ACCORDING TO THE SELECTED DIVISION
        importDivisionBriefTemplate:function(){
            var division_id = activeInstance.activeDivisionId;
            $.each(activeInstance.briefTemplates,function(index,division){
                console.log(division);
                if(division.id == division_id){
                    activeInstance.activeDivision = division;
                }
            });
            activeInstance.importProjectBriefValues();
        },
        //IMPORT PROJECT BRIEF VALUES INTO THE BRIEF TEMPLATE
        importProjectBriefValues:function(){
            $.each(activeInstance.project.project_brief,function(index,project_brief_field){
                $.each(activeInstance.activeDivision.brief_template,function(index2,brief_template_field){
                    if(project_brief_field.brief_field_id == brief_template_field.brief_field_id){
                        brief_template_field.field_data.value = project_brief_field.value;
                    }
                });
            });
        },
        //REMOVE AN ASSIGNEE
        removeAssignee:function(assignee){
            activeInstance.project.assignees.$remove(assignee);
        },
        //LOAD PROJECT DETAILS
        loadProjectDetails:function(){
            showLoadingOverlay();
            Vue.http.get(baseURL + '/api/project/list/one/'+activeInstance.project_id,function(response){
                $('body').LoadingOverlay("hide");

                response.start= response.start.substring(0,10);
                activeInstance.project = response;

                activeInstance.activeClient = response.client;
                activeInstance.getClientBrands();
                activeInstance.activeBrand = response.brand;
                activeInstance.activeSubBrand = response.sub_brand;
                activeInstance.activeBrandId=response.brand_id;
                activeInstance.activeSubBrandId=response.sub_brand_id;
                activeInstance.activeDivisionId=response.division_id;

                setTimeout(function(){
                    activeInstance.importDivisionBriefTemplate();
                    activeInstance.loadActivePhase();
                },200);

                $('#clientsearchfield').val(activeInstance.project.client.name);

                $.each(activeInstance.project.files,function(index,file){
                    var dropZoneFile = {};
                    dropZoneFile.progress = 100;
                    dropZoneFile.file_record_id = file.id;
                    dropZoneFile.name = file.filename;
                    activeInstance.dropZoneFiles.push(dropZoneFile);
                });


                activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                    activeInstance.subBrands = response.data;

                    activeInstance.activeBrandId = $(event.target).val();
                    $.each(activeInstance.subBrands, function(index,sub_brand){
                        console.log('searching...');

                        if(sub_brand.id==activeInstance.activeSubBrandId){
                            console.log('found...');
                            activeInstance.activeSubBrand = sub_brand;

                        }
                    });

                }).bind(this);


                var el = document.getElementById('stages');
                    var sortable = new Sortable(el, {
                        onSort: function (/**Event*/evt) {
                            console.log(evt);
                        },
                    });


            });


        },
        phaseChange: function(point) {
            if (activeInstance.project.phase.machine_name == point.machine_name) {
                return;
            }

            if (activeInstance.project.phase.machine_name == 'completed') {
                bootbox.alert("Nincs jogosultságod a projekt státuszát változtatni.");
                return;
            }

            if (point.machine_name == 'completed') {
                bootbox.alert("A projektet kizárólag a pénzügy zárhatja véglegesen.");
                return;
            }

            bootbox.confirm("Biztosan átváltod a fázist a következőre: "+point.name+"?",
                function(result){
                    if (result) {

                        if (point.machine_name == 'client_approved') {
                            bootbox.confirm({
                                message: "Igényel számlázást a project?",
                                buttons: {
                                    confirm: {
                                        label: 'Igen',
                                        className: 'btn-success'
                                    },
                                    cancel: {
                                        label: 'Nem',
                                        className: 'btn-danger'
                                    }
                                },
                                callback: function(result) {
                                    activeInstance.invoice_required = result;
                                    activeInstance.phaseChangePost(point);
                                    return;
                                }
                            });
                        } else {
                            activeInstance.phaseChangePost(point);
                        }
                    }
                });

        },
        phaseChangePost: function(point) {
            showLoadingOverlay();
            axios.post(baseURL+'/api/project/set/phase', {
                project_id: activeInstance.project.id,
                phase_machine_name: point.machine_name,
                invoice_required: activeInstance.invoice_required
            }).then(function (resp) {
                $('body').LoadingOverlay("hide");

                activeInstance.project.phase = point;
            }).catch(function (error) {
                $('body').LoadingOverlay("hide");
                console.log(error);
            });
        },
        loadActivePhase:function(){
          activeInstance.phase_list.forEach(function(phase){
             if(phase.machine_name == activeInstance.project.phase){
                 activeInstance.project.phase = phase;
             }
          });
        },
        edit:function(project){
            location.href = baseURL+'/admin/project/edit/'+project.id;
        },
        destroy:function(project){
            bootbox.confirm('Biztosan el akarod távolítani ezt a céget?', function(value){
                if(value!=null){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/project/destroy',{project:project}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('A projekt törölve.');
                        activeInstance.list.$remove(project);
                    });
                }
            });
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(){
            activeInstance.$http.get(baseURL+'/api/brand/list/client/'+activeInstance.activeClient.id).then(function(response){
                activeInstance.brands = response.data;
            }).bind(this);
        },
        //GET SUB BRANDS BELONGS TO A BRAND
        getBrandSubBrands:function(event,data){

            activeInstance.activeBrandId = $(event.target).val();

            $.each(activeInstance.brands, function(index,brand){
                if(brand.id==activeInstance.activeBrandId){
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                activeInstance.subBrands = response.data;
            }).bind(this);

        },
        setActiveSubBrand:function(event){

            var subBrandId = $(event.target).val();

            $.each(activeInstance.subBrands, function(index,sub_brand){
                if(sub_brand.id==subBrandId){
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        },
        save:function(){

            var files = jQuery.extend(true, {}, activeInstance.dropZoneFiles);

            $.each(files,function(index,file){
                delete file.file;
            });

            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/project/update',{
                'project_id':activeInstance.project.id,
                'name':activeInstance.project.name,
                'brand_id':activeInstance.activeBrandId,
                'sub_brand_id':activeInstance.activeSubBrandId,
                'client_id':activeInstance.activeClient.id,
                'assignees':activeInstance.project.assignees,
                'completion_month':parseInt(activeInstance.project.completion_month),
                'division_id':activeInstance.activeDivisionId,
                'brief_data': activeInstance.activeDivision.brief_template,
                'files':files,
                'deadline':activeInstance.project.deadline,
                'stages':activeInstance.project.stages
            }).then(function(response){
                //console.log(response);
                $('body').LoadingOverlay("hide");
                successNotification('Sikeres mentés');

                setTimeout(function(){
                    window.location = baseURL + '/admin/project/'+activeInstance.project.id;
                },400);
            }).catch(function (error, data) {
                $('body').LoadingOverlay("hide");
                $.each(error.data,function(key, value){
                    errorNotification(value);
                    $('#'+key).addClass('error');
                });
            });
        }
    }
});